import request from '@/utils/request'

export function updateAirshipCfg(data) {
  return request({
    url: 'api/v1/airship/updateCfg',
    method: 'post',
    data: data
  })
}

export function getAirshipCfgList(data) {
  return request({
    url: 'api/v1/airship/getList',
    method: 'post',
    data: data
  })
}

export function delAirshipCfg(data) {
  return request({
    url: 'api/v1/airship/delFirst',
    method: 'delete',
    data: data
  })
}

